var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Roll_ic",
    transform: "translate(-1020 -187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14043",
    "data-name": "Rectangle 14043",
    width: 20,
    height: 20,
    transform: "translate(1020 187)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34265",
    "data-name": "Group 34265",
    transform: "translate(289.917 645.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40387",
    "data-name": "Path 40387",
    d: "M948.452,347.664c-3.519,0-6.524.533-6.524,2.662S944.914,353,948.452,353c3.518,0,6.522-.528,6.522-2.658S951.989,347.664,948.452,347.664Z",
    transform: "translate(-208.36 -793.459)",
    fill: "none",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40388",
    "data-name": "Path 40388",
    d: "M948.249,345.612a4.166,4.166,0,1,0-.031,0Z",
    transform: "translate(-208.157 -794.445)",
    fill: "none",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.ab70cd81.svg";
export { ForwardRef as ReactComponent };